import { css } from '@emotion/core';
import { colorsPalette } from '../../../../styles/colors';
import MediaQueries from '../../../../styles/Grid/MediaQueries';
import { typography } from '../../../../styles/typography';

export const container = css({
  [MediaQueries.smAndUp]: {
    width: '100%',
  },
  [MediaQueries.mdAndUp]: {
    paddingLeft: 16,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 24,
  },
});

export const solutionPart = css(typography.effra16);

export const solutionLabel = css(typography.effra16, {
  color: colorsPalette.grey60,
  [MediaQueries.mdAndUp]: {
    width: '37%',
  },
});

export const solutionsContainer = css({
  marginBottom: 8,

  '&:last-child': {
    marginBottom: 0,
  },

  [MediaQueries.mdAndUp]: {
    display: 'flex',
  },
});

export const headline = css(typography.effra16, {
  color: colorsPalette.grey,
  marginBottom: 16,
});

export const solutionPrice = css(typography.effra16, {
  color: colorsPalette.teal,
  marginBottom: 6,

  [MediaQueries.mdAndUp]: {
    paddingLeft: '3%',
    width: '60%',
  },
});
